<template name="CarNumber">
  <div class="visit-show">
    <div class="content">
      <div class="row">
        <div class="col-8 name">{{$t('numberPlate')}}</div>
        <div class="col-4 close" @click="closeModal"><i class="iconfont icon-close"></i></div>
      </div>
      <div class="row input-view">
        <div class="col-4 carName">{{$t('numberPlate')}}</div>
        <div class="col-8 carId"> <input type="text" v-model="carNumber" name="" :placeholder="$t('typeNumberPlate')"></div>
      </div>
      <label v-show="errorCar" class="error-msg">{{$t('typeNumberPlate')}}</label>
      <div class="bottom" :class="{'hideMargin': this.errorCar}">
        <div class="save" @click="saveCarNumber"><span>{{$t('save')}}</span></div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import Bus from '@/utils/Bus';
  import { editCarNumber }from '@/utils/api';
  import { checkNested } from '@/utils/utils';
  export default {
    name: 'CarNumber',
    props: {
    },
    data() {
      return {
        carModal: false,
        callbackMessage: '',
        carNumber: '',
        visitorId: '',
        ticketId: '',
        addNewCarNumber: false,
        errorCar: false,
        carNumberIsRequired: false,
      }
    },
    methods: {
      closeModal() {
        this.errorCar = false;
        this.$emit('closeUpdateCarNumber', false);
      },
      saveCarNumber() {
        const data = {
          "ticketId": this.ticketId,
          "visitorId": this.visitorId,
          "carNumber": this.carNumber
        }
        if (this.carNumberIsRequired) {
          if (this.carNumber !='') {
            this.errorCar = false;
            editCarNumber(data).then((res) => {
             if (checkNested(res, 'data', 'content')) {
               if (res.data.content.model) {
                if (this.addNewCarNumber) {
                   this.callbackMessage = this.$t('saveSuccessfully');
                 } else {
                   this.callbackMessage = this.$t('updatedSuccessfully');
                 }
               } else {
                  this.callbackMessage = res.data.content.message;
               }
               this.$emit('saveCarNumber', true, this.callbackMessage,false);
             }
            })
          } else {
            this.errorCar = true;
          }
        } else {
          this.errorCar = false;
          editCarNumber(data).then((res) => {
           if (checkNested(res, 'data', 'content')) {
             if (res.data.content.model) {
              if (this.addNewCarNumber) {
                 this.callbackMessage = this.$t('saveSuccessfully');
               } else {
                 this.callbackMessage = this.$t('updatedSuccessfully');
               }
             } else {
                this.callbackMessage = res.data.content.message;
             }
             this.$emit('saveCarNumber', true, this.callbackMessage,false);
           }
          })
        }

      },
      loadData(data) {
        this.carNumber = data.carNumber;
        this.visitorId = data.visitorId;
        this.ticketId = data.ticketId;
        this.addNewCarNumber = data.carNumber == '' ? true : false;
        this.carNumberIsRequired = data.carNumberIsRequired;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/variables.scss";
  .visit-show {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top:0;
    z-index: 1032;
    background:rgba(0, 0, 0, 0.4);
    .content {
      width: 449px;
      height: 168px;
      border-radius: 4px;
      background: #fff;
      position: relative;
      left: calc(100%/2 - 449px/2);
      top: calc(100%/2 - 168px/2);
      padding: 20px;
      .row {
        margin: 0;
      }
      .name {
        font-size: 16px;
        color: #4a4a4a;
        font-weight: 600;
      }
      .input-view {
        line-height: 35px;
        border-bottom: 1px solid #f0f1f2;
      }
      .close {
        padding-right: 0;
        font-size: 15px;
        text-align: right;
        position: absolute;
        right: 5px;
        top: 5px;
        cursor: pointer;
        i {
          font-size: 32px;
          color: #000;
          font-weight: normal;
        }
      }
      .carName {
        font-size: 13px;
        color: #4a4a4a;
        span {
          color: #929292;
          font-size: 12px;
        }
      }
      .carId {
        font-size: 13px;
        color: #929292;
        input {
          width: 100%;
          text-align: right;
          line-height: 20px;
        }
        input::-ms-clear {
          display: none;
        }
      }
      .bottom {
        width: 100%;
        text-align: center;
        margin-top: 20px;
        &.hideMargin {
          margin-top: 0;
        }
      }
      .save {
        width: 189px;
        height: 40px;
        line-height: 40px;
        border-radius: 5px;
        margin: 0 auto;
        background-image: -webkit-linear-gradient(352deg, #f36443, #e42029);
        background-image: -o-linear-gradient(352deg, #f36443, #e42029);
        background-image: linear-gradient(82deg, #f36443, #e42029);
        cursor: pointer;
        span {
          font-size: 15px;
          font-weight: 600;
          color: #fff;
        }
      } 
    }
    @include respond-to('sm-max') {
      .content {
        width: 80%;
        border-radius: 4px;
        background: #fff;
        position: relative;
        height: 200px;
        left: calc(100%/2 - 80%/2);
        top: calc(100%/2 - 200px/2);
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .row {
          margin: 0;
          width: 100%;
        }
        .name {
          font-size: 16px;
          color: #4a4a4a;
          font-weight: 600;
          padding-left: 0;
        }
        .input-view {
          line-height: 35px;
          border-bottom: 1px solid #f0f1f2;
        }
        .close {
          padding-right: 0;
          font-size: 15px;
          text-align: right;
          position: absolute;
          right: 7px;
          top: 7px;
          cursor: pointer;
          i {
            font-size: 28px;
            color: #000;
            font-weight: normal;
          }
        }
        .carName {
          font-size: 13px;
          color: #4a4a4a;
          span {
            color: #929292;
            font-size: 12px;
          }
          padding-left: 0;
          padding-right: 0;
        }
        .carId {
          font-size: 13px;
          color: #929292;
          input {
            width: 100%;
            text-align: right;
          }
        }
        .bottom {
          width: 100%;
          text-align: center;
          margin-top: 20px;
          &.hideMargin {
            margin-top: 0;
          }
        }
        .save {
          width: 189px;
          height: 40px;
          line-height: 40px;
          border-radius: 5px;
          margin: 0 auto;
          background-image: -webkit-linear-gradient(352deg, #f36443, #e42029);
          background-image: -o-linear-gradient(352deg, #f36443, #e42029);
          background-image: linear-gradient(82deg, #f36443, #e42029);
          cursor: pointer;
          span {
            font-size: 15px;
            font-weight: 600;
            color: #fff;
          }
        } 
      }
    }
    @include respond-to('ml') {
      .content {
        width: 80%;
        border-radius: 4px;
        background: #fff;
        position: relative;
        left: calc(100%/2 - 80%/2);
        top: calc(100%/2 - 168px/2);
        padding: 20px;
        .row {
          margin: 0;
        }
        .name {
          font-size: 16px;
          color: #4a4a4a;
          font-weight: 600;
        }
        .input-view {
          line-height: 35px;
          border-bottom: 1px solid #f0f1f2;
        }
        .close {
          padding-right: 0;
          font-size: 15px;
          text-align: right;
          position: absolute;
          right: 5px;
          top: 5px;
          cursor: pointer;
          i {
            font-size: 32px;
            color: #000;
            font-weight: normal;
          }
        }
        .carName {
          font-size: 13px;
          color: #4a4a4a;
          span {
            color: #929292;
            font-size: 12px;
          }
        }
        .carId {
          font-size: 13px;
          color: #929292;
          input {
            width: 100%;
            text-align: right;
          }
        }
        .bottom {
          width: 100%;
          text-align: center;
          margin-top: 20px;
          &.hideMargin {
            margin-top: 0;
          }
        }
        .save {
          width: 189px;
          height: 40px;
          line-height: 40px;
          border-radius: 5px;
          margin: 0 auto;
          background-image: -webkit-linear-gradient(352deg, #f36443, #e42029);
          background-image: -o-linear-gradient(352deg, #f36443, #e42029);
          background-image: linear-gradient(82deg, #f36443, #e42029);
          cursor: pointer;
          span {
            font-size: 15px;
            font-weight: 600;
            color: #fff;
          }
        } 
      }
    }
    .error-msg {
      color: #e42029;
      font-size: 11px;
      text-align: right;
      width: 100%;
      margin-bottom: 0;
    }
  }
</style>